'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUniqueValues(array, prop) {
    return array.map(function (item) {
        return item[prop];
    }).filter(function (item, index, self) {
        return self.indexOf(item) === index;
    }); // distinct
}

var MakeModelYears = {
    init: function init() {
        MakeModelYears.data = null;
        MakeModelYears.makemodelyears = null;
        MakeModelYears.uniqueMakes = null;
        MakeModelYears.make = null;
        MakeModelYears.model = null;
        MakeModelYears.year = null;

        _jquery2.default.get(window.theme.makemodelyearsUrl, function (data) {
            MakeModelYears.makemodelyears = data;
            MakeModelYears.uniqueMakes = getUniqueValues(MakeModelYears.makemodelyears, "make").sort();
            MakeModelYears.data = data;

            document.querySelectorAll('[data-load-mmy]').forEach(function (form) {
                MakeModelYears.getMMYFromUrl();
                MakeModelYears.loadmakeModelYear();
                if (form.getAttribute('data-load-mmy') == 'model') {
                    var make = form.querySelector('#make').value;
                    MakeModelYears.buildModelOptions(form, make);
                } else if (form.getAttribute('data-load-mmy') == 'all') {
                    MakeModelYears.make = form.getAttribute('data-load-make');
                    MakeModelYears.model = form.getAttribute('data-load-model');
                    MakeModelYears.year = form.getAttribute('data-load-year');

                    MakeModelYears.buildMakeOptions(form);
                } else {
                    MakeModelYears.buildMakeOptions(form);
                }
            });
        });
    },

    getMMYFromUrl: function getMMYFromUrl() {
        var url = window.location.href.split('?')[0];
        var slug = url.split('gallery/');

        if (slug.length < 2) {
            return;
        }

        var values = slug[1].split('/');
        document.querySelectorAll('[data-load-mmy]').forEach(function (form) {
            if (values.length >= 3) {
                var mmy = MakeModelYears.getMMYBySlug(values[0], values[1], values[2]);
                form.setAttribute('data-load-make', mmy.make);
                form.setAttribute('data-load-model', mmy.model);
                form.setAttribute('data-load-year', mmy.year);
            } else if (values.length == 2) {
                var _mmy = MakeModelYears.getMMYBySlug(values[0], values[1]);
                form.setAttribute('data-load-make', _mmy.make);
                form.setAttribute('data-load-model', _mmy.model);
            } else if (values.length == 1) {
                var _mmy2 = MakeModelYears.getMMYBySlug(values[0]);
                form.setAttribute('data-load-make', _mmy2.make);
            }
        });
    },

    loadmakeModelYear: function loadmakeModelYear() {
        var slug = document.querySelector('[data-slugs]');
        if (slug !== null) {
            var make = slug.getAttribute('data-slug-make');
            var model = slug.getAttribute('data-slug-model');
            var year = slug.getAttribute('data-slug-year');

            if (make && model && year) {
                var mmy = MakeModelYears.getMMYBySlug(make, model, year);
                slug.innerHTML = ' ' + mmy.make + ' ' + mmy.model + ' ' + mmy.year;
            } else if (make && model) {
                var _mmy3 = MakeModelYears.getMMYBySlug(make, model);
                slug.innerHTML = ' ' + _mmy3.make + ' ' + _mmy3.model;
            } else {
                var _mmy4 = MakeModelYears.getMMYBySlug(make, model);
                slug.innerHTML = ' ' + _mmy4.make;
            }
        }
    },

    // Returns a list of all models based off make passed in 
    getModelsbyMake: function getModelsbyMake(make) {
        var all = MakeModelYears.makemodelyears.filter(function (a) {
            return a.make == make;
        });
        return getUniqueValues(all, "model").sort();
    },

    // Returns a list of all available years passed in based off make and model 
    getYearsbyModel: function getYearsbyModel(make, model) {
        var all = MakeModelYears.makemodelyears.filter(function (a) {
            return a.make == make;
        });
        var models = all.filter(function (a) {
            return a.model == model;
        });
        return getUniqueValues(models, "year").sort();
    },

    getCenterByMMY: function getCenterByMMY(make, model, year) {
        var mmy = MakeModelYears.makemodelyears.filter(function (mmy) {
            return mmy.make == make && mmy.model == model && mmy.year == year;
        });
        return mmy[0].centers;
    },

    getExclusionsByMMY: function getExclusionsByMMY(make, model, year) {
        var mmy = MakeModelYears.makemodelyears.filter(function (mmy) {
            return mmy.make == make && mmy.model == model && mmy.year == year;
        });
        return mmy[0].exclusions;
    },

    getSlug: function getSlug(make, model, year) {
        var slug = null;
        if (make != null && model != null && year != null) {
            var mmy = MakeModelYears.makemodelyears.filter(function (mmy) {
                return mmy.make == make && mmy.model == model && mmy.year == year;
            });
            slug = mmy[0].makeSlug + '/' + mmy[0].modelSlug + '/' + mmy[0].yearSlug;
        } else if (make != null && model != null) {
            var mm = MakeModelYears.makemodelyears.filter(function (mmy) {
                return mmy.make == make && mmy.model == model;
            });
            slug = mm[0].makeSlug + '/' + mm[0].modelSlug;
        } else if (make != null) {
            var m = MakeModelYears.makemodelyears.filter(function (mmy) {
                return mmy.make == make;
            });
            slug = '' + m[0].makeSlug;
        }

        return slug;
    },

    getMMYBySlug: function getMMYBySlug(make, model, year) {
        var mmy = null;
        if (make != null && model != null && year != null) {
            mmy = MakeModelYears.makemodelyears.filter(function (mmy) {
                return mmy.makeSlug == make && mmy.modelSlug == model && mmy.yearSlug == year;
            });
        } else if (make != null && model != null) {
            mmy = MakeModelYears.makemodelyears.filter(function (mmy) {
                return mmy.makeSlug == make && mmy.modelSlug == model;
            });
        } else if (make != null) {
            mmy = MakeModelYears.makemodelyears.filter(function (mmy) {
                return mmy.makeSlug == make;
            });
        }

        return mmy[0];
    },

    // Builds and populated html options for make dropdown
    buildMakeOptions: function buildMakeOptions(form) {
        var makeSelectElement = form.querySelector('#make');
        if (makeSelectElement) {
            var makeOptions = "<option value=''>Make</option>";
            MakeModelYears.uniqueMakes.forEach(function (make) {
                var option = '<option value="' + make + '">' + make + '</option>';
                makeOptions += option;
            });

            makeSelectElement.innerHTML = makeOptions;
            makeSelectElement.addEventListener('change', function (event) {
                MakeModelYears.clearModelOptions(form);
                MakeModelYears.clearYearOptions(form);
                MakeModelYears.buildModelOptions(form, event.target.value, 'change');
            });

            if (MakeModelYears.make) {
                makeSelectElement.value = MakeModelYears.make;
                MakeModelYears.buildModelOptions(form, MakeModelYears.make, 'triggered');
            }
        }
    },

    // Clears model options
    clearModelOptions: function clearModelOptions(form) {
        var modelSelectElement = form.querySelector('#model');
        if (modelSelectElement) {
            modelSelectElement.innerHTML = "<option value=''>Model</option>";
        }
    },

    // Builds and populated html options for model dropdown
    buildModelOptions: function buildModelOptions(form, make, type) {
        var modelSelectElement = form.querySelector('#model');
        if (modelSelectElement) {
            var uniqueModels = MakeModelYears.getModelsbyMake(make);
            var modelOptions = "<option value=''>Model</option>";
            uniqueModels.forEach(function (model) {
                var option = '<option value="' + model + '">' + model + '</option>';
                modelOptions += option;
            });

            modelSelectElement.innerHTML = modelOptions;

            modelSelectElement.addEventListener('change', function (event) {
                MakeModelYears.buildYearOptions(form, make, event.target.value, 'change');
            });

            if (MakeModelYears.model && type == 'triggered') {
                modelSelectElement.value = MakeModelYears.model;
                MakeModelYears.buildYearOptions(form, MakeModelYears.make, MakeModelYears.model, 'triggered');
            }
        }
    },

    // Clears year options
    clearYearOptions: function clearYearOptions(form) {
        var yearSelectElement = form.querySelector('#year');
        if (yearSelectElement) {
            yearSelectElement.innerHTML = "<option value=''>Year</option>";
        }
    },

    // Builds and populated html options for year dropdown
    buildYearOptions: function buildYearOptions(form, make, model, type) {
        var yearSelectElement = form.querySelector('#year');
        if (yearSelectElement) {
            var uniqueModels = MakeModelYears.getYearsbyModel(make, model);
            var yearOptions = "<option value=''>Year</option>";
            uniqueModels.forEach(function (year) {
                var option = '<option value="' + year + '">' + year + '</option>';
                yearOptions += option;
            });
            yearSelectElement.innerHTML = yearOptions;

            if (MakeModelYears.year && type == 'triggered') {
                yearSelectElement.value = MakeModelYears.year;
            }
        }
    }
};

exports.default = MakeModelYears;